import React, { useEffect } from "react";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import { useThunkDispatch } from "@redux/dispatcher";
import { set as setLocales } from "@redux/modules/value/locales/locales.module";

import LanguageSelector from "./languageSelector.component";

export type LanguageSelectorContainerProps = {
    variant?: string;
    currentLanguage: string;
    layout: "default" | "list" | "toggle";
};

const LanguageSelectorContainer = ({
    variant,
    currentLanguage,
    layout,
}: LanguageSelectorContainerProps) => {
    const languages = useIsClientSide()
        ? window.configuration.languageItems
        : [];
    const dispatch = useThunkDispatch();

    useEffect(() => {
        dispatch(
            setLocales({
                current: currentLanguage,
                locales: languages,
            }),
        );
    }, [languages]);

    return (
        <LanguageSelector
            layout={layout || "default"}
            current={currentLanguage}
            variant={variant}
            languages={languages}
        />
    );
};

export { LanguageSelectorContainer };
